module.exports = __webpack_public_path__ + "static/img/wantai.9a059d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handoff/clients/wantai.png
// module id = oXmg
// module chunks = 1